
(function () {
  'use strict';

  var KLUCZ_POWROTU = 'bramowe-home-drive-powrot';
  var KLUCZ_FORMULARZA = 'bramowe-home-drive-formularz';
  var KROKI = ['typ', 'krok2', 'krok3', 'priorytet'];

  var CZAS = {
    potwierdzenie: 250,
    zwijanie: 300,
    odslona: 400,
    ladowanie: 900,
    ladowanieBezRuchu: 600
  };

  function bezRuchu() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function pusteOdpowiedzi() {
    var odp = {};
    for (var i = 0; i < KROKI.length; i += 1) odp[KROKI[i]] = null;
    return odp;
  }

  function malaLitera(tekst) {
    return tekst ? tekst.charAt(0).toLocaleLowerCase('pl') + tekst.slice(1) : '';
  }

  function etykieta(przycisk) {
    var nazwa = przycisk.querySelector('.bh-choice__name');
    return nazwa ? nazwa.textContent.trim() : '';
  }

  function widoczny(el) {
    var wariant = el.closest('[data-bh-drive-for]');
    return !wariant || !wariant.hidden;
  }

  function pierwszyWidoczny(lista) {
    for (var i = 0; i < lista.length; i += 1) if (widoczny(lista[i])) return lista[i];
    return null;
  }

  function czytajPowrot() {
    try {
      var surowe = window.sessionStorage.getItem(KLUCZ_POWROTU);
      return surowe ? JSON.parse(surowe) : null;
    } catch (e) { return null; }
  }

  function zapiszPowrot(odp) {
    try { window.sessionStorage.setItem(KLUCZ_POWROTU, JSON.stringify(odp)); } catch (e) {}
  }

  function usunPowrot() {
    try { window.sessionStorage.removeItem(KLUCZ_POWROTU); } catch (e) {}
  }

  function zdejmijFormularz() {
    var stan = null;
    try {
      var surowe = window.sessionStorage.getItem(KLUCZ_FORMULARZA);
      stan = surowe ? JSON.parse(surowe) : null;
      window.sessionStorage.removeItem(KLUCZ_FORMULARZA);
    } catch (e) { stan = null; }
    return stan;
  }

  function zablokujPrzewijanie(tak) {
    document.documentElement.classList.toggle('bh-scroll-locked', !!tak);
  }

  function nawigacjaWstecz() {
    try {
      var wpisy = window.performance.getEntriesByType('navigation');
      return !!(wpisy && wpisy[0] && wpisy[0].type === 'back_forward');
    } catch (e) { return false; }
  }

  function zdarzenie(nazwa, dane) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(nazwa, dane || {});
      }
    } catch (e) {}
  }

  var CZAS_ZJAZDU_ZAPAS = 320;

  function zZjazdem() {
    return window.matchMedia('(max-width: 768px)').matches && !bezRuchu();
  }

  function Kreator(korzen) {
    this.korzen = korzen;
    this.okno = korzen.querySelector('[data-bh-drive-dialog]');
    var modul = korzen.closest ? korzen.closest('[data-bh-start]') : null;
    this.otwieracz = (modul || korzen).querySelector('[data-bh-drive-open]');
    this.kroki = {};
    var li = korzen.querySelectorAll('[data-bh-step]');
    for (var i = 0; i < li.length; i += 1) this.kroki[li[i].getAttribute('data-bh-step')] = li[i];
    this.warianty = [].slice.call(korzen.querySelectorAll('[data-bh-drive-for]'));
    this.wynik = korzen.querySelector('[data-bh-drive-result]');
    this.ladowanie = korzen.querySelector('[data-bh-drive-loading]');
    this.karty = [].slice.call(korzen.querySelectorAll('[data-bh-drive-card]'));
    this.podsumowanie = korzen.querySelector('[data-bh-drive-recap]');
    this.resety = [].slice.call(korzen.querySelectorAll('[data-bh-drive-reset]'));
    this.reset = korzen.querySelector('.bh-drive__reset');
    this.miernik = korzen.querySelector('[data-bh-drive-meter]');
    this.segmenty = [].slice.call(korzen.querySelectorAll('[data-bh-drive-seg]'));
    this.cialo = korzen.querySelector('.bh-drive__body');
    this.ekrany = [].slice.call(korzen.querySelectorAll('[data-bh-drive-screen]'));
    this.etykietaProduktu = this.okno ? this.okno.getAttribute('data-bh-drive-product-label') || '' : '';

    this.odp = pusteOdpowiedzi();
    this.timery = [];
    this.zajety = false;
    this.uchwyty = [];
    this.podlacz();
  }

  Kreator.prototype.nasluch = function (cel, nazwa, funkcja) {
    cel.addEventListener(nazwa, funkcja);
    this.uchwyty.push([cel, nazwa, funkcja]);
  };

  Kreator.prototype.pozniej = function (funkcja, ms) {
    this.timery.push(window.setTimeout(funkcja, ms));
  };

  Kreator.prototype.przerwij = function () {
    for (var i = 0; i < this.timery.length; i += 1) window.clearTimeout(this.timery[i]);
    this.timery = [];
    this.zajety = false;
  };

  Kreator.prototype.rozlacz = function () {
    this.przerwij();
    for (var i = 0; i < this.uchwyty.length; i += 1) {
      this.uchwyty[i][0].removeEventListener(this.uchwyty[i][1], this.uchwyty[i][2]);
    }
    this.uchwyty = [];
  };

  Kreator.prototype.podlacz = function () {
    if (!this.okno) return;
    var self = this;

    if (this.otwieracz) {
      this.nasluch(this.otwieracz, 'click', function () { self.otworz('karta'); });
    }

    KROKI.forEach(function (krok) {
      var li = self.kroki[krok];
      if (!li) return;
      [].slice.call(li.querySelectorAll('[data-bh-drive-value]')).forEach(function (przycisk) {
        self.nasluch(przycisk, 'click', function () { self.wybierz(krok, przycisk); });
      });
    });

    this.resety.forEach(function (btn) {
      self.nasluch(btn, 'click', function () {
        self.wyzeruj(true);
        self.fokusNa('typ');
      });
    });

    [].slice.call(this.korzen.querySelectorAll('[data-bh-drive-close]')).forEach(function (btn) {
      self.nasluch(btn, 'click', function () { self.zamknij(); });
    });

    this.nasluch(this.okno, 'click', function (ev) {
      if (ev.target === self.okno) self.zamknij();
    });

    this.nasluch(this.okno, 'cancel', function (ev) {
      if (!zZjazdem()) return;
      ev.preventDefault();
      self.zamknij();
    });

    this.nasluch(this.okno, 'animationend', function (ev) {
      if (ev.target === self.okno && self.zamykanie) self.domknij();
    });

    this.nasluch(this.okno, 'close', function () {
      self.zakonczZjazd();
      self.ogloszenie('bh:drive:close');
      self.przerwij();
      usunPowrot();
      zablokujPrzewijanie(false);
      var powrot = self.powrot && document.contains(self.powrot) ? self.powrot : self.otwieracz;
      self.powrot = null;
      if (powrot) powrot.focus({ preventScroll: true });
    });

    [].slice.call(this.korzen.querySelectorAll('[data-bh-drive-screen-open]')).forEach(function (btn) {
      self.nasluch(btn, 'click', function () { self.pokazEkran(btn.getAttribute('data-bh-drive-screen-open'), false, 'wynik'); });
    });
    this.nasluch(this.okno, 'click', function (ev) {
      var wstecz = ev.target.closest ? ev.target.closest('[data-bh-drive-back]') : null;
      if (wstecz) { self.pokazEkran(null); return; }
      var kopiuj = ev.target.closest ? ev.target.closest('[data-bh-drive-copy]') : null;
      if (kopiuj) self.kopiuj(kopiuj);
    });
    this.ekrany.forEach(function (ekran) {
      var formularz = ekran.querySelector('form');
      if (!formularz) return;
      self.nasluch(formularz, 'submit', function () {
        try {
          window.sessionStorage.setItem(KLUCZ_FORMULARZA, JSON.stringify({
            odp: self.odp,
            ekran: ekran.getAttribute('data-bh-drive-screen'),
            formularz: formularz.id
          }));
        } catch (e) {}
      });
    });

    this.karty.forEach(function (karta) {
      var link = karta.querySelector('[data-bh-drive-go]');
      if (link) self.nasluch(link, 'click', function () { zapiszPowrot(self.odp); });
    });

    this.nasluch(window, 'pageshow', function (ev) {
      if (!ev.persisted) return;
      zablokujPrzewijanie(self.okno.open);
      var stan = czytajPowrot();
      if (stan) self.przywroc(stan);
      else {
        self.wyzeruj();
        if (self.okno.open) self.okno.close();
      }
    });

    var kotwica = window.location.hash || '';
    if ((kotwica === '#bh-dobor-rabat' || kotwica === '#bh-dobor-doradca') && window.history.replaceState) {
      window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search);
    }

    var stan = nawigacjaWstecz() ? czytajPowrot() : null;
    var formularz = zdejmijFormularz();
    this.wyzeruj();
    if (formularz && this.poWyslaniu(formularz)) return;
    if (stan) this.przywroc(stan);
  };

  Kreator.prototype.ogloszenie = function (nazwa) {
    var modul = this.korzen.closest ? this.korzen.closest('[data-bh-start]') : null;
    if (modul) modul.dispatchEvent(new CustomEvent(nazwa));
  };

  Kreator.prototype.pokazOkno = function () {
    zablokujPrzewijanie(true);
    if (this.okno.open) return;
    this.ogloszenie('bh:drive:open');
    if (typeof this.okno.showModal === 'function') this.okno.showModal();
    else this.okno.setAttribute('open', '');
  };

  Kreator.prototype.zamknij = function () {
    var self = this;
    if (zZjazdem() && this.okno.open && typeof this.okno.close === 'function') {
      if (this.zamykanie) return;
      this.zamykanie = true;
      this.okno.classList.add('bh-drive__dialog--zjazd');
      this.ogloszenie('bh:drive:zamykanie');
      this.zapasZjazdu = window.setTimeout(function () { self.domknij(); }, CZAS_ZJAZDU_ZAPAS);
      return;
    }
    this.domknij();
  };

  Kreator.prototype.zakonczZjazd = function () {
    this.zamykanie = false;
    if (this.zapasZjazdu) window.clearTimeout(this.zapasZjazdu);
    this.zapasZjazdu = null;
    this.okno.classList.remove('bh-drive__dialog--zjazd');
  };

  Kreator.prototype.domknij = function () {
    this.zakonczZjazd();
    if (typeof this.okno.close === 'function') { if (this.okno.open) this.okno.close(); }
    else {
      this.okno.removeAttribute('open');
      zablokujPrzewijanie(false);
      this.ogloszenie('bh:drive:close');
    }
  };

  Kreator.prototype.bezPrzejsc = function (zmiana) {
    var okno = this.okno;
    okno.classList.add('bh-drive__dialog--cicho');
    zmiana();
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        okno.classList.remove('bh-drive__dialog--cicho');
      });
    });
  };

  Kreator.prototype.fokusNa = function (krok) {
    var li = this.kroki[krok];
    var pierwszy = li ? pierwszyWidoczny(li.querySelectorAll('[data-bh-drive-value]')) : null;
    if (pierwszy) pierwszy.focus({ preventScroll: true });
  };

  Kreator.prototype.otworz = function (zrodlo) {
    zdarzenie('bramowe_home_drive_start', { zrodlo: zrodlo || 'inne' });
    var aktywny = document.activeElement;
    this.powrot = aktywny && aktywny !== document.body ? aktywny : null;
    this.wyzeruj();
    this.pokazOkno();
    this.fokusNa('typ');
  };

  Kreator.prototype.ustawKrok = function (krok, stan) {
    var li = this.kroki[krok];
    if (!li) return;
    li.setAttribute('data-state', stan);
    var dostepny = stan === 'aktywny' || stan === 'potwierdzony';
    if (dostepny || stan === 'zrobiony') {
      li.removeAttribute('inert');
      li.removeAttribute('aria-hidden');
    } else {
      li.setAttribute('inert', '');
      li.setAttribute('aria-hidden', 'true');
    }
  };

  Kreator.prototype.przycisk = function (krok, wartosc) {
    var li = this.kroki[krok];
    return li ? pierwszyWidoczny(li.querySelectorAll('[data-bh-drive-value="' + wartosc + '"]')) : null;
  };

  Kreator.prototype.slowoKroku = function (krok) {
    var li = this.kroki[krok];
    var el = li ? pierwszyWidoczny(li.querySelectorAll('[data-bh-step-label]')) : null;
    return el ? el.textContent.trim() : '';
  };

  Kreator.prototype.ustawPostep = function () {
    var self = this;
    var zrobione = KROKI.filter(function (k) { return self.odp[k] !== null; }).length;
    var biezacy = Math.min(zrobione + 1, KROKI.length);
    this.segmenty.forEach(function (seg, i) {
      seg.style.transform = 'scaleX(' + (i < zrobione ? 1 : 0) + ')';
    });
    if (this.miernik) {
      var wzor = this.miernik.getAttribute('data-bh-drive-meter-label') || '';
      this.miernik.setAttribute('aria-label', wzor.replace('[n]', biezacy).replace('[m]', KROKI.length));
    }
  };

  Kreator.prototype.iskierki = function (zrodlo) {
    if (!zrodlo || bezRuchu() || !this.okno.animate) return;
    var okno = this.okno;
    var ro = okno.getBoundingClientRect();
    var rz = zrodlo.getBoundingClientRect();
    var x = rz.left + rz.width / 2 - ro.left;
    var y = rz.top + rz.height / 2 - ro.top;
    var ile = 3 + Math.round(Math.random());
    var start = Math.random() * Math.PI * 2;
    for (var i = 0; i < ile; i += 1) {
      var rozmiar = 6 + Math.round(Math.random() * 4);
      var kat = start + (i / ile) * Math.PI * 2 + (Math.random() - 0.5) * 0.6;
      var dystans = 10 + Math.random() * 6;
      var sx = x + Math.cos(kat) * rz.width / 2;
      var sy = y + Math.sin(kat) * rz.height / 2;
      var dx = Math.cos(kat) * dystans;
      var dy = Math.sin(kat) * dystans;
      var ns = 'http://www.w3.org/2000/svg';
      var svg = document.createElementNS(ns, 'svg');
      svg.setAttribute('viewBox', '0 0 10 10');
      svg.setAttribute('width', rozmiar);
      svg.setAttribute('height', rozmiar);
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('class', 'bh-drive__spark');
      var path = document.createElementNS(ns, 'path');
      path.setAttribute('d', 'M5 0 6.1 3.9 10 5 6.1 6.1 5 10 3.9 6.1 0 5 3.9 3.9Z');
      svg.appendChild(path);
      svg.style.left = (sx - rozmiar / 2) + 'px';
      svg.style.top = (sy - rozmiar / 2) + 'px';
      okno.appendChild(svg);
      var ruch = svg.animate([
        { transform: 'translate(0, 0) scale(0)', opacity: 1 },
        { transform: 'translate(' + (dx * 0.6) + 'px, ' + (dy * 0.6) + 'px) scale(1)', opacity: 1, offset: 0.4 },
        { transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(0)', opacity: 0 }
      ], { duration: 500, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' });
      ruch.onfinish = (function (el) { return function () { el.remove(); }; }(svg));
    }
  };

  Kreator.prototype.zatwierdz = function (krok, wartosc) {
    this.odp[krok] = wartosc;
    var przycisk = this.przycisk(krok, wartosc);
    var li = this.kroki[krok];
    if (przycisk) przycisk.classList.add('bh-choice--wybrany');
    var pole = li.querySelector('[data-bh-step-value]');
    if (pole && przycisk) pole.textContent = malaLitera(etykieta(przycisk));
    this.ustawKrok(krok, 'zrobiony');
    this.ustawPostep();
    if (krok === 'typ' && przycisk) this.pokazGrupe(przycisk.getAttribute('data-bh-drive-group'));
    if (this.reset) this.reset.classList.remove('bh-drive__reset--ukryty');
  };

  Kreator.prototype.pokazGrupe = function (grupa) {
    for (var i = 0; i < this.warianty.length; i += 1) {
      this.warianty[i].hidden = this.warianty[i].getAttribute('data-bh-drive-for') !== grupa;
    }
  };

  Kreator.prototype.wyzeruj = function (plynnie) {
    var self = this;
    this.przerwij();
    usunPowrot();
    this.odp = pusteOdpowiedzi();
    this.bezPrzejsc(function () {
      KROKI.forEach(function (krok, i) {
        self.ustawKrok(krok, i === 0 ? 'aktywny' : 'zablokowany');
        var li = self.kroki[krok];
        if (!li) return;
        li.classList.remove('bh-step--zwija');
        [].slice.call(li.querySelectorAll('.bh-choice--wybrany')).forEach(function (el) {
          el.classList.remove('bh-choice--wybrany');
        });
        var pole = li.querySelector('[data-bh-step-value]');
        if (pole) pole.textContent = '';
      });
      if (self.warianty[0]) self.pokazGrupe(self.warianty[0].getAttribute('data-bh-drive-for'));
      self.okno.setAttribute('data-state', 'kroki');
      [].slice.call(self.korzen.querySelectorAll('.bh-drive--wchodzi')).forEach(function (el) {
        el.classList.remove('bh-drive--wchodzi');
      });
      if (self.podsumowanie) self.podsumowanie.textContent = '';
      self.pokazWynik('zablokowany');
      self.pokazEkran(null, true);
      self.wyczyscBledy();
      if (self.reset) self.reset.classList.add('bh-drive__reset--ukryty');
      if (!plynnie) self.ustawPostep();
    });
    if (plynnie) {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () { self.ustawPostep(); });
        });
      });
    }
  };

  Kreator.prototype.wybierz = function (krok, przycisk) {
    var li = this.kroki[krok];
    if (this.zajety || !li || li.getAttribute('data-state') !== 'aktywny') return;
    this.zajety = true;
    var self = this;

    przycisk.classList.add('bh-choice--wybrany');
    this.ustawKrok(krok, 'potwierdzony');
    this.iskierki(przycisk.querySelector('.bh-drive__tick'));

    this.pozniej(function () {
      var nastepny = KROKI[KROKI.indexOf(krok) + 1];
      var przesuwane = [];
      KROKI.forEach(function (k) { if (k !== krok && self.kroki[k]) przesuwane.push(self.kroki[k]); });
      if (self.wynik) przesuwane.push(self.wynik);

      var przed = przesuwane.map(function (el) { return el.getBoundingClientRect().top; });
      li.classList.add('bh-step--zwija');
      self.zatwierdz(krok, przycisk.getAttribute('data-bh-drive-value'));
      if (!nastepny) {
        self.pokazStanWyniku();
        if (self.wynik) self.wynik.classList.add('bh-drive--wchodzi');
      }
      self.plynnie(przesuwane, przed);

      self.pozniej(function () {
        self.zajety = false;
        if (nastepny) {
          var nizej = KROKI.slice(KROKI.indexOf(nastepny) + 1).map(function (k) { return self.kroki[k]; }).filter(Boolean);
          var przedOdslona = nizej.map(function (el) { return el.getBoundingClientRect().top; });
          self.ustawKrok(nastepny, 'aktywny');
          self.plynnie(nizej, przedOdslona);
          self.fokusNa(nastepny);
        } else {
          self.laduj();
        }
      }, bezRuchu() ? 0 : CZAS.zwijanie);
    }, CZAS.potwierdzenie);
  };

  Kreator.prototype.plynnie = function (elementy, przed) {
    if (bezRuchu()) return;
    elementy.forEach(function (el, i) {
      var roznica = przed[i] - el.getBoundingClientRect().top;
      if (!roznica) return;
      el.classList.remove('bh-drive__flip');
      el.style.transform = 'translateY(' + roznica + 'px)';
      void el.offsetHeight;
      el.classList.add('bh-drive__flip');
      el.style.transform = '';
    });
  };

  Kreator.prototype.pokazStanWyniku = function () {
    var self = this;
    if (this.podsumowanie) {
      this.podsumowanie.textContent = KROKI.map(function (k) {
        var p = self.przycisk(k, self.odp[k]);
        return p ? etykieta(p) : '';
      }).join(' · ');
    }
    this.okno.setAttribute('data-state', 'wynik');
  };

  Kreator.prototype.karta = function () {
    var self = this;
    if (KROKI.some(function (k) { return self.odp[k] === null; })) return null;
    var klucz = KROKI.map(function (k) { return self.odp[k]; }).join('|');
    for (var i = 0; i < this.karty.length; i += 1) {
      if (this.karty[i].getAttribute('data-bh-drive-card') === klucz) return this.karty[i];
    }
    return null;
  };

  Kreator.prototype.pokazWynik = function (stan) {
    if (!this.wynik) return null;
    var trafiona = stan === 'wynik' ? this.karta() : null;
    this.wynik.setAttribute('data-state', stan);
    if (this.ladowanie) this.ladowanie.hidden = stan !== 'ladowanie';
    for (var i = 0; i < this.karty.length; i += 1) this.karty[i].hidden = this.karty[i] !== trafiona;
    return trafiona;
  };

  Kreator.prototype.laduj = function () {
    var self = this;
    this.zajety = true;
    this.pokazWynik('ladowanie');
    this.pozniej(function () {
      self.zajety = false;
      var karta = self.pokazWynik('wynik');
      zdarzenie('bramowe_home_drive_complete', {
        wynik: karta ? 'produkt' : 'doradca',
        produkt: karta ? karta.getAttribute('data-bh-drive-handle') || '' : ''
      });
      if (karta) {
        karta.classList.add('bh-drive--wchodzi');
        karta.focus({ preventScroll: true });
        self.pozniej(function () {
          self.iskierki(karta.querySelector('[data-bh-drive-badge]') || karta);
        }, 80);
      } else {
        self.pokazEkran('doradca', false, 'indywidualnie');
      }
    }, bezRuchu() ? CZAS.ladowanieBezRuchu : CZAS.ladowanie);
  };

  Kreator.prototype.przywroc = function (stan) {
    var self = this;
    if (!stan || KROKI.some(function (k) { return !stan[k]; })) { usunPowrot(); return; }
    this.bezPrzejsc(function () {
      self.wyzeruj();
      KROKI.forEach(function (k) { self.zatwierdz(k, stan[k]); });
      self.pokazStanWyniku();
      if (!self.pokazWynik('wynik')) self.pokazEkran('doradca', true, 'indywidualnie');
    });
    zapiszPowrot(this.odp);
    this.pokazOkno();
    var karta = this.karta();
    if (karta) karta.focus({ preventScroll: true });
  };

  Kreator.prototype.uzupelnijFormularze = function () {
    var self = this;
    var karta = this.karta();
    var nazwa = karta ? ((karta.querySelector('[data-bh-drive-name]') || {}).textContent || '').trim() : '';
    var cena = karta ? ((karta.querySelector('.bh-drive__price') || {}).textContent || '').trim() : '';
    var czesci = KROKI.map(function (k, i) {
      var p = self.przycisk(k, self.odp[k]);
      var wartosc = malaLitera(p ? etykieta(p) : '');
      var slowo = self.slowoKroku(k);
      if (i === 0) return slowo + ' ' + wartosc;
      return malaLitera(slowo) + (k === 'priorytet' ? ': ' : ' ') + wartosc;
    });
    var polecony = karta ? nazwa + (cena ? ', ' + cena : '') : (this.okno.getAttribute('data-bh-drive-no-product') || '');
    var opis = czesci.join(', ') + '. ' + this.etykietaProduktu + ': ' + polecony + '.';
    [].slice.call(this.korzen.querySelectorAll('[data-bh-drive-summary]')).forEach(function (pole) { pole.value = opis; });
  };

  Kreator.prototype.pokazEkran = function (nazwa, bezRuchuEkranu, tryb) {
    this.okno.setAttribute('data-tryb', tryb || 'wynik');
    var cel = null;
    for (var i = 0; i < this.ekrany.length; i += 1) {
      var ten = this.ekrany[i].getAttribute('data-bh-drive-screen') === nazwa;
      this.ekrany[i].hidden = !ten;
      this.ekrany[i].classList.toggle('bh-drive--wchodzi', ten && !bezRuchuEkranu);
      if (ten) cel = this.ekrany[i];
    }
    if (this.cialo) {
      this.cialo.hidden = !!cel;
      this.cialo.classList.toggle('bh-drive--wchodzi', !cel && !bezRuchuEkranu);
    }
    this.okno.setAttribute('data-ekran', nazwa || 'kroki');
    if (cel) {
      this.uzupelnijFormularze();
      var wstecz = cel.querySelector('[data-bh-drive-back]');
      if (tryb === 'indywidualnie') cel.focus({ preventScroll: true });
      else if (wstecz) wstecz.focus({ preventScroll: true });
    } else {
      var karta = this.karta();
      var akcja = karta ? karta.querySelector('[data-bh-drive-screen-open]') : null;
      if (akcja && !bezRuchuEkranu) akcja.focus({ preventScroll: true });
    }
    return cel;
  };

  Kreator.prototype.poWyslaniu = function (stan) {
    var ekran = this.korzen.querySelector('[data-bh-drive-screen="' + stan.ekran + '"]');
    if (!ekran || !stan.odp) return false;
    var szukaj = window.location.search || '';
    var wyslany = /(contact|customer)_posted=true/.test(szukaj) && ekran.querySelector('[data-bh-drive-sent]');
    var blad = ekran.querySelector('[data-bh-drive-error]');
    if (!wyslany && !blad) return false;

    this.przywroc(stan.odp);
    this.pokazEkran(stan.ekran, true, this.karta() ? 'wynik' : 'indywidualnie');
    var cel = null;
    if (wyslany) {
      cel = this.pokazSukces(ekran, true);
    } else {
      [].slice.call(ekran.querySelectorAll('[data-bh-drive-error]')).forEach(function (el) { el.hidden = false; });
      cel = ekran.querySelector('[data-bh-drive-invalid]');
      if (cel) cel.setAttribute('aria-invalid', 'true');
    }
    var self = this;
    var modul = this.korzen.closest('.bh-section');
    zablokujPrzewijanie(false);
    var ustaw = function () {
      window.setTimeout(function () {
        if (cel) cel.focus({ preventScroll: true });
        window.setTimeout(function () {
          if (modul && window.BramoweHomeScroll) window.BramoweHomeScroll.doCelu(modul);
          window.setTimeout(function () { zablokujPrzewijanie(self.okno.open); }, 900);
        }, 50);
      }, 200);
    };
    if (document.readyState === 'complete') ustaw();
    else this.nasluch(window, 'load', ustaw);
    return true;
  };

  Kreator.prototype.wyczyscBledy = function () {
    [].slice.call(this.korzen.querySelectorAll('[data-bh-drive-error]')).forEach(function (el) { el.hidden = true; });
    [].slice.call(this.korzen.querySelectorAll('[data-bh-drive-invalid]')).forEach(function (el) {
      el.removeAttribute('aria-invalid');
    });
    [].slice.call(this.korzen.querySelectorAll('[data-bh-drive-sent]')).forEach(function (el) { el.hidden = true; });
    [].slice.call(this.korzen.querySelectorAll('[data-bh-drive-fields]')).forEach(function (el) { el.hidden = false; });
    this.ekrany.forEach(function (el) { el.classList.remove('bh-drive__screen--sukces'); });
  };

  Kreator.prototype.pokazSukces = function (ekran, bezRuchuSukcesu) {
    var self = this;
    var pola = ekran.querySelector('[data-bh-drive-fields]');
    if (pola) pola.hidden = true;
    var sukces = ekran.querySelector('[data-bh-drive-sent]');
    if (!sukces) return null;
    sukces.hidden = false;
    ekran.classList.add('bh-drive__screen--sukces');
    var karta = this.karta();
    var link = karta ? karta.querySelector('[data-bh-drive-go]') : null;
    var cta = sukces.querySelector('[data-bh-drive-sent-cta]');
    if (cta) {
      if (link) {
        cta.href = link.href;
        cta.hidden = false;
        this.nasluch(cta, 'click', function () { zapiszPowrot(self.odp); });
      } else {
        cta.hidden = true;
      }
    }
    var znak = sukces.querySelector('[data-bh-drive-done-mark]');
    if (znak && !bezRuchuSukcesu) {
      znak.classList.add('bh-drive--wchodzi');
      this.pozniej(function () { self.iskierki(znak); }, 150);
    }
    sukces.focus({ preventScroll: true });
    return sukces;
  };

  Kreator.prototype.kopiuj = function (btn) {
    var kod = this.korzen.querySelector('[data-bh-drive-code]');
    if (!kod || !navigator.clipboard) return;
    navigator.clipboard.writeText(kod.textContent.trim()).then(function () {
      var po = btn.getAttribute('data-bh-drive-copied');
      var etykietaKopii = btn.querySelector('[data-bh-drive-copy-label]');
      if (po && etykietaKopii) etykietaKopii.textContent = po;
      btn.classList.add('bh-drive__copy--gotowe');
    }).catch(function () {});
  };

  var instancje = new WeakMap();

  function uruchom(zakres) {
    var korzenie = (zakres || document).querySelectorAll('[data-bh-drive]');
    for (var i = 0; i < korzenie.length; i += 1) {
      if (instancje.has(korzenie[i])) continue;
      instancje.set(korzenie[i], new Kreator(korzenie[i]));
    }
  }

  function zatrzymaj(zakres) {
    var korzenie = (zakres || document).querySelectorAll('[data-bh-drive]');
    for (var i = 0; i < korzenie.length; i += 1) {
      var instancja = instancje.get(korzenie[i]);
      if (instancja) { instancja.rozlacz(); instancje.delete(korzenie[i]); }
    }
  }

  window.BramoweHomeDrive = {
    otworz: function (zrodlo) {
      var korzen = document.querySelector('[data-bh-drive]');
      var instancja = korzen ? instancje.get(korzen) : null;
      if (instancja) instancja.otworz(zrodlo);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { uruchom(); });
  } else {
    uruchom();
  }

  document.addEventListener('shopify:section:load', function (ev) { uruchom(ev.target); });
  document.addEventListener('shopify:section:unload', function (ev) { zatrzymaj(ev.target); });
}());
